/**
 * Mantine's modal `onClose` carries no reason, so the close pathways (the X
 * button, the overlay, the Escape key) tag their trigger here and ModalTitle
 * consumes it on unmount to fill modalClose's `modalButton` / `modalCloseType`
 * (§ 3.5). The value is reset when a modal opens so a stale tag can't carry over.
 */
export type ModalCloseInfo = {
  modalButton?: "Button" | "Cross" | "Shadow";
  modalCloseType?: string;
};

let pending: ModalCloseInfo = {};

export const markModalClose = (info: ModalCloseInfo) => {
  pending = info;
};

export const consumeModalClose = (): ModalCloseInfo => {
  const info = pending;
  pending = {};
  return info;
};
